/**
 * Where each kind of identifier goes. One place, so every guid on every screen is clickable
 * and lands somewhere consistent.
 *
 * Carrier and event have no screen of their own: a carrier scopes the loads list, and an
 * event resolves through the engine's `/search`, which routes to the batch that carried it.
 */

export const linkTo = {
  load: (guid: string | null | undefined) => (guid ? `/loads/${guid}` : undefined),
  driver: (guid: string | null | undefined) => (guid ? `/drivers/${guid}` : undefined),
  device: (guid: string | null | undefined) => (guid ? `/devices/${guid}` : undefined),
  batch: (guid: string | null | undefined) => (guid ? `/batches/${guid}` : undefined),
  carrier: (guid: string | null | undefined) => (guid ? `/loads?carrier_guid=${guid}` : undefined),
  event: (guid: string | null | undefined) => (guid ? `/search?q=${guid}` : undefined),
  /** A root is load-or-trip; only loads have a screen so far. */
  root: (rootType: string, guid: string | null | undefined) =>
    rootType === "load" ? linkTo.load(guid) : undefined,
  rootTimeline: (rootType: string, guid: string | null | undefined) =>
    rootType === "load" && guid ? `/loads/${guid}?tab=timeline` : undefined,
  rootBatches: (guid: string) => `/batches?root_guid=${guid}`,
  driverLoads: (guid: string) => `/loads?driver_guid=${guid}`,
  driverBatches: (guid: string) => `/batches?driver_guid=${guid}`,
  deviceBatches: (guid: string) => `/batches?device_guid=${guid}`,
} as const;

const BY_COLUMN: Record<string, (guid: string) => string | undefined> = {
  driver_guid: linkTo.driver,
  carrier_guid: linkTo.carrier,
  device_guid: linkTo.device,
  batch_guid: linkTo.batch,
  last_applied_batch_guid: linkTo.batch,
  load_guid: linkTo.load,
  event_guid: linkTo.event,
  last_event_guid: linkTo.event,
  winning_event_guid: linkTo.event,
};

export function linkForColumn(
  column: string,
  guid: string,
  row: Record<string, unknown>,
): string | undefined {
  if (column === "root_guid") return linkTo.root(String(row["root_type"] ?? ""), guid);
  return BY_COLUMN[column]?.(guid);
}
